import io from 'socket.io-client'

export var DefaultSocketURL = window.socketURL || 'http://localhost:8090'; 
//export var DefaultSocketURL = 'http://10.0.1.123';
//export var DefaultSocketURL = 'https://www.lawtomata.com/cwsapi'; 
export var socketURL = null;
export var socket = null;
  

export const connect = (urlString) => {
  const url = new URL(urlString);
  console.log('Connecting socket IO to', url);
  socketURL = url;
  if (socket) {
    socket.close();
  }
  const slash = url.pathname.endsWith('/') ? '' : '/';
  socket = io.connect(url.origin, {path: url.pathname + slash + 'socket.io'});
  console.log(socket);
  socket.on('connect', () => {
    console.log('SocketIO: connecting');
  });
  
  socket.on('reconnect', () => {
    console.log('SocketIO: reconnecting');
  });
   
  socket.on('connect_response', (msg) => {
    console.log('SocketIO: connect response: ', msg)
    connectCallBack(msg);  
  });
  
  socket.on('disconnect', () => {
    console.log('SocketIO: disconnecting.');
  });
  
  socket.on('connect_error', (err) => {
    // We get a 401 unauthorized if we are logged out
    // We get a ERR_CONNECTION_REFUSED if the server is down...
    console.log('SocketIO: connect error', JSON.stringify(err));
    connectErrCallBack(err);
  });

}

//connect(DefaultSocketURL);

var connectCallBack = (msg) => {};
var connectErrCallBack = (e) => {};

export const setConnectCallBack = (cb) => {
  connectCallBack = cb;
}

export const setConnectErrCallBack = (cb) => {
  connectErrCallBack = cb;
}

